export default "__VITE_ASSET__DrPhiXer__"